export default [
  {
    path: '/:lang?/coupon/:code',
    name: 'coupon-page',
    component: () => import('@/views/coupon/CouponPage.vue'),
  },
];
